// extracted by mini-css-extract-plugin
module.exports = {"input":"WordSearchForm_input_3ygeG","search_word_wrap":"WordSearchForm_search_word_wrap_eff4c","search_word_icon":"WordSearchForm_search_word_icon_AgRdZ"};